import { render, staticRenderFns } from "./inputDialog.vue?vue&type=template&id=70460bf9"
import script from "./inputDialog.vue?vue&type=script&lang=js"
export * from "./inputDialog.vue?vue&type=script&lang=js"
import style0 from "./inputDialog.vue?vue&type=style&index=0&id=70460bf9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports